<template>
<v-layout>
  <v-flex>
    <router-link :to="{name: 'monitorGroupsList'}">&lt;&lt;Back to Monitoring Groups List</router-link>
    <v-card>
      <v-card-title>
        <h3>{{accessGroup.name}}
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-icon v-if="accessGroup.default">group</v-icon>
              </template>
              <span>Public Group</span>
            </v-tooltip>
           </h3>
      </v-card-title>
      <v-card-text>
  <v-form v-model="valid" @submit.prevent>
    <v-layout>
      <v-flex xs6 pr-4>
        <v-layout wrap>
          <v-flex xs-12 pr-4>
            <v-text-field
              label="Name"
              v-model="accessGroup.name"
              @input="changed"
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 pr-4>
            <v-textarea
              label="Description"
              v-model="accessGroup.description"
              @input="changed"
              ></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 pl-4>
        <div>
            <v-select
              label="Service Account"
              :items="getAvailableUsers"
              v-model="selectedUserId"
              item-text="login"
              item-value="id"
              @input="changed"
              ></v-select>
        </div>
          <div>
            <v-checkbox :input-value="accessGroup.default" v-on:click.stop="changeDefault($event)" label="Public"></v-checkbox>
          </div>
          <v-checkbox v-model="accessGroup.uniformSecurity" label="Uniform Credentials"></v-checkbox>
          <div v-if="accessGroup.uniformSecurity">
            <span v-if="endpointCount === 0">
              This feature requires at least one fully configured Endpoint in the monitoring group.
            </span>
            <span v-if="hasEpWNoCreds">
              Please ensure credentials are set for Endpoints in the monitoring group.
            </span>
            <span v-if="hasEpWcreds">
              When new Endpoints are added to this monitoring group, they will inherit credentials from existing Endpoints in this group.
            </span>
            <p></p>
            <v-btn v-if="endpointCount > 0" text @click="pwdChangeDialog = true" color="primary">Bulk Reset Credentials for Member Endpoints</v-btn>
          </div>
        </v-flex>
      </v-layout>

      <v-layout>
        <!-- <v-flex xs6 ma-1>
        <v-btn :disabled="!selectedAllEndpoints.length" @click="assignEndpoints()" class="was-orange" color="primary" outlined rounded>Add selected Endpoints to Monitoring Group&gt;&gt;</v-btn>
        <endpoints-grid
        :endpoints="getAvailableEndpoints" title="Available Endpoints" :rowsPerPage=5 :loading="loading" :selection=true
        :showId=false v-on:selectionChanged="availableEndpointsSelectionChanged" :reset="resetFlag"
        ></endpoints-grid>
        </v-flex> -->
        <v-flex>
        <endpoints-grid
        :endpoints="accessGroup.endpoints" title="Member Endpoints" :rowsPerPage=5 :loading="loading" :selection=true
        :showId=false v-on:selectionChanged="memberEndpointsSelectionChanged" :reset="resetFlag"
        ></endpoints-grid>
        <v-btn :disabled="!selectedMemberEndpoints.length" @click="unassignEndpoints()" class="mt-4 mr-4 was-orange" color="primary" outlined rounded>Remove selected Endpoints from Monitoring Group</v-btn>
        <v-btn @click="showAddEndpointDialog = true" class="mt-4 mr-4 was-orange" color="primary" outlined rounded>Add Endpoints</v-btn>
        <v-btn @click="resetEndpoints()" class="mt-4 mr-4 was-orange" color="primary" outlined rounded>Reset Endpoint Memberships</v-btn>
        <v-btn v-if="getControlHubEndpoints.length" @click="showConfigAdminsDialog()" class="mt-4 mr-4 was-green" color="primary" outlined rounded>Configure Admin Accounts via ControlHub</v-btn>
        </v-flex>
      </v-layout>
  </v-form>
      </v-card-text>
      <v-card-actions>
                <v-btn :disabled="!valid" @click="saveAccessGroup()" color="primary">Save</v-btn>
      </v-card-actions>
    </v-card>

  <v-dialog v-model="showAddEndpointDialog" max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline">Add Endpoints to Monitoring Group</span>
      </v-card-title>
        <v-card-text>
          <endpoints-grid
          :showAllEndpointsCheckbox="true"
          :endpoints="getAvailableEndpoints" title="Available Endpoints" :rowsPerPage=5 :loading="loading" :selection=true
          :showId=false v-on:selectionChanged="availableEndpointsSelectionChanged" :reset="resetFlag"
          v-on:unassignedEndpointsChanged="unassignedEndpointsChanged"
          ></endpoints-grid>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mr-4" color="primary" outlined rounded  @click="showAddEndpointDialog = false">Close</v-btn>
          <v-btn color="primary" rounded  :disabled="!selectedAllEndpoints.length" @click="assignEndpoints()">Add Selected Endpoints</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="configAdminsDialog" max-width="700px">
    <v-card>
      <v-card-title>
        <span class="headline">Configure Admin Accounts for {{ getControlHubEndpoints.length }} ControlHub Endpoints</span>
        <span v-if="getNonControlHubEndpoints.length" class="caption">({{ getNonControlHubEndpoints.length }} Endpoints are non-ControlHub and will not be affected)</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="validXapi" @submit.prevent>
        <v-layout wrap>
          <v-flex xs-12 pr-4>
            <v-text-field
              label="Username"
              v-model="xapiadminusername"
              disabled
              :rules="[rules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 pr-4>
            <v-text-field
              type="password"
              label="Password"
              v-model="xapiadminuserpassword"
              :rules="[rules.required, rules.pwdFormat]"
              ></v-text-field>
          </v-flex>
          <v-flex xs12 pr-4>
              Please do not share this password with other vendors or users.
          </v-flex>
        </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
          <v-btn class="mr-4" color="primary" outlined rounded  @click="hideConfigAdminsDialog">Close</v-btn>
        <v-btn color="primary" outlined rounded  @click="configXapiAdmins()" :disabled="!validXapi">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="pwdChangeDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Set Password for {{endpointCount}} Endpoints in Monitoring Group</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validPwd" @submit.prevent>
              <v-text-field v-model="newLogin" :rules="[rules.required]" label="Login"></v-text-field>
              <v-text-field v-model="newPassword" :rules="[rules.required]" type="password" label="Password"></v-text-field>
              <v-text-field v-model="confirmPassword" :rules="[rules.match]" type="password" label="Confirm Password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="primary" outlined rounded  @click.native="pwdChangeDialog = false">Cancel</v-btn>
            <v-btn color="primary" rounded  :disabled="!validPwd" @click.native="saveBulkPassword">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!-- <v-layout>
        <v-flex xs6 ma-1>
        <v-btn :disabled="!selectedAllUsers.length" @click="assignUsers()" class="was-orange" color="primary" outlined rounded>Add selected Users to Monitoring Group&gt;&gt;</v-btn>
        <users-grid
        :datasource="getAvailableUsers" title="Available Users" :rowsPerPage=5 :loading="loading" :selection=true
        :showId=false v-on:selectionChanged="availableUsersSelectionChanged" :reset="resetFlag"
        :initSearch="initSearch"
        ></users-grid>
        </v-flex>
        <v-flex xs6 ma-1>
        <v-btn :disabled="!selectedMemberUsers.length" @click="unassignUsers()" class="was-orange" color="primary" outlined rounded>&lt;&lt;Remove selected Users from Monitoring Group</v-btn>
        <users-grid
        :datasource="accessGroup.users" title="Member Users" :rowsPerPage=5 :loading="loading" :selection=true
        :showId=false v-on:selectionChanged="memberUsersSelectionChanged" :reset="resetFlag"
        ></users-grid>
        <v-btn @click="resetUsers()" class="was-orange" color="primary" outlined rounded>Reset User Memberships</v-btn>
        </v-flex>
        </v-layout> -->
  </v-flex>
</v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import EndpointsGrid from './EndpointsGrid.vue'
import UsersGrid from './UsersGrid.vue'
export default {
  components: {
    'endpoints-grid': EndpointsGrid,
    'users-grid': UsersGrid
  },
  data() {
    return {
      showAddEndpointDialog: false,
      selectedMemberEndpoints: [],
      selectedAllEndpoints: [],
      // selectedMemberUsers: [],
      // selectedAllUsers: [],
      resetFlag: false,
      loading: false,
      loadingUsers: false,
      stepIndex: 0,
      valid: false,
      validXapi: false,
      initSearch: 'svc',
      xapiadminusername: 'vyopta_epm',
      xapiadminuserpassword: '',
      configAdminsDialog: false,
      showUnassignedEndpoints: true,
      pwdChangeDialog: false,
      validPwd: false,
      newLogin: '',
      newPassword: '',
      confirmPassword: '',
      rules: {
        required: value => !!value || 'Required',
        match: value => value === this.newPassword || 'Passwords do not match',
        pwdFormat: value => !value || /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,16}$/.test(value) || 'Password must be 8-16 chars long and contain a digit, a lower case and an upper case letter'
      }
    }
  },
  computed: {
    ...mapGetters('endpoints', {
        accessGroup: 'activeAccessGroup',
        allEndpoints: 'activeEndpoints'
    }),
    ...mapGetters('user', {
        allUsers: 'adminUsers',
        ccoUsers: 'getCcoUsers'
    }),
    getAvailableEndpoints: function() {
      let resetFlag = this.resetFlag // to force re-compute
      let memberIds = _.map(this.accessGroup.endpoints, 'id')

      let result = _.reject(this.allEndpoints, (endpoint) => {
        return memberIds.includes(endpoint.id) || 
        (this.showUnassignedEndpoints &&
         (!_.isEmpty(endpoint.accessGroups) && _.find(endpoint.accessGroups, {deleted: false})))
      })
      // console.log('members: ' + memberIds.length + ' result: ' + result.length)
      return result
    },
    getControlHubEndpoints: function() {
      return _.filter(this.accessGroup.endpoints, (ep) => {
        return ep.externalId && _.startsWith(ep.externalId, 'sparkId:')
      })
    },
    getNonControlHubEndpoints: function() {
      return _.reject(this.accessGroup.endpoints, (ep) => {
        return ep.externalId && _.startsWith(ep.externalId, 'sparkId:')
      })
    },
    getAvailableUsers: function() {
      var regex = new RegExp('\\bEndpoint', 'i')
      var ccoUsers = _.filter(this.ccoUsers, (user) => {
          return regex.test(user.login) // || user.login.toLowerCase().includes('default')
      })
      return _.concat([], this.allUsers, ccoUsers)
    },
    selectedUserId: {
      get() {
        return this.accessGroup && this.accessGroup.users
            && this.accessGroup.users[0] && this.accessGroup.users[0].id
      },
      set(val) {
        const usr = _.find(this.getAvailableUsers, {id: val})
        this.accessGroup.users = [usr]
      }
    },
    endpointCount: function() {
      return this.accessGroup && this.accessGroup.endpoints && this.accessGroup.endpoints.length ? this.accessGroup.endpoints.length : 0
    },
    hasEpWcreds: function() {
      if (this.endpointCount === 0) {
        return false
      }
      const f = _.find(this.accessGroup.endpoints, { hasCredentials: true })
      return !!f
    },
    hasEpWNoCreds: function() {
      if (this.endpointCount === 0) {
        return false
      }
      const f = _.find(this.accessGroup.endpoints, { hasCredentials: true })
      return !f
    }
    // isDefault: {
    //   get() {
    //     this.accessGroup.default
    //   },
    //   set(val) {
    //     if (!val || confirm('Setting this group as default will unmark any other group that is currently the default. Do you wish to continue?')) {
    //       this.accessGroup.default = val
    //     }
    //   }
    // }
  },
  async created () {
    await this.$store.dispatch("endpoints/getAccessGroup", this.$route.params.id);
  },
  mounted() {
        if (_.isEmpty(this.allEndpoints) || _.isEmpty(this.allUsers)) {
            this.$router.replace({name: 'monitorGroupsList'})
        }
  },
  methods: {
    getAliases(aliases) {
      if (!aliases) {
        return ''
      }
      let tokens = _.split(aliases, '/')
      return _.join(_.without(tokens, ''), ', ')
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    async saveAccessGroup() {
      await this.$store.dispatch("endpoints/saveAccessGroup", this.accessGroup)
      this.$router.replace({ name: "monitorGroupsList" });
    },
    changed() {

    },
    changeDefault(event) {
      if (this.accessGroup.default || confirm('Setting this group as default will unmark any other group that is currently the default. Do you wish to continue?')) {
        this.accessGroup.default = !this.accessGroup.default
      }
    },
    availableEndpointsSelectionChanged(selection) {
      this.selectedAllEndpoints = selection
    },
    memberEndpointsSelectionChanged(selection) {
      this.selectedMemberEndpoints = selection
    },
    // availableUsersSelectionChanged(selection) {
    //   this.selectedAllUsers = selection
    // },
    // memberUsersSelectionChanged(selection) {
    //   this.selectedMemberUsers = selection
    // },
    assignEndpoints() {
      this.accessGroup.endpoints = this.accessGroup.endpoints || []
      this.accessGroup.endpoints.splice(this.accessGroup.endpoints.length, 0, ...this.selectedAllEndpoints)
      this.resetFlag = !this.resetFlag
      this.selectedAllEndpoints = []
      this.showAddEndpointDialog = false
    },
    unassignEndpoints() {
      this.accessGroup.endpoints = this.accessGroup.endpoints || []

      let idsToRemove = _.map(this.selectedMemberEndpoints, 'id')

      _.forEach(idsToRemove, (id) => {
        let p = _.findIndex(this.accessGroup.endpoints, {'id': id})
        this.accessGroup.endpoints.splice(p,1)
      })
      this.resetFlag = !this.resetFlag
      this.selectedMemberEndpoints = []
    },
    assignUsers() {
      this.accessGroup.users = this.accessGroup.users || []
      this.accessGroup.users.splice(this.accessGroup.users.length, 0, ...this.selectedAllUsers)
      this.resetFlag = !this.resetFlag
      this.selectedAllUsers = []
    },
    unassignUsers() {
      this.accessGroup.users = this.accessGroup.users || []
      let idsToRemove = _.map(this.selectedMemberUsers, 'id')

      _.forEach(idsToRemove, (id) => {
        let p = _.findIndex(this.accessGroup.users, {'id': id})
        this.accessGroup.users.splice(p,1)
      })
      this.resetFlag = !this.resetFlag
      this.selectedMemberUsers = []
    },
    resetEndpoints() {
      this.$store.dispatch("endpoints/resetActiveAccessGroupEndpoints")
    },
    resetUsers() {
      this.$store.dispatch("endpoints/resetActiveAccessGroupUsers")
    },
    cancel() {
      this.$router.replace({ name: "monitorGroupsList" });
    },
    showConfigAdminsDialog() {
      this.configAdminsDialog = true
    },
    hideConfigAdminsDialog() {
      this.configAdminsDialog = false
    },
    async configXapiAdmins() {
      const accessGroupId = this.accessGroup.id
      const xapiAdminProps = {username: this.xapiadminusername, password: this.xapiadminuserpassword, endpoints: this.getControlHubEndpoints, systemId: null}
      const result = await this.$store.dispatch("endpoints/configureXapiAdminAccounts", {accessGroupId, xapiAdminProps})
      alert(result)
      this.configAdminsDialog = false
    },
    unassignedEndpointsChanged(data) {
      this.showUnassignedEndpoints = data
    },
    async saveBulkPassword() {
      let endpointIds = _.map(this.accessGroup.endpoints, 'id')
      let success = await this.$store.dispatch('endpoints/setBulkPassword', { endpointIds, newLogin: this.newLogin, newPassword: this.newPassword })
      if (success) {
        this.activeAccessGroupForPwd = {}
        this.pwdChangeDialog = false
      }
    },
  }
}
</script>
